import { makeAutoObservable } from "mobx";

export interface IResultMap extends Record<string, any> {
  selectCityMap?: Record<string, any>; // 选择城市
  words?: {
    prefixWords?: string[];
    keywords?: string[];
    suffixWords?: string[];
  };
  topics?: {
    keyword?: any[];
    word?: any[];
  };
  titles?: any[]; // 推荐标题
  lines?: any[]; // 台词
}

export interface ISeo {
  selectWord: any;
  resultMap: Record<string, IResultMap>;
  sensitiveIds: number[];
}

class SeoStore {
  words = {
    prefixWords: [],
    keywords: [],
    suffixWords: [],
  };
  selectCityMap = {};
  selectWord = null;
  resultMap = {};
  sensitiveIds = [];
  constructor() {
    makeAutoObservable(this);
  }

  get topics() {
    return this.resultMap[this.selectWord?.id]?.topics ?? [];
  }

  get isLoading() {
    return (
      this.resultMap[this.selectWord?.id]?.titleLoading ||
      this.resultMap[this.selectWord?.id]?.lineLoading ||
      this.resultMap[this.selectWord?.id]?.topicLoading
    );
  }

  setSelectCityMap(v: any) {
    this.selectCityMap = v;
  }

  setSelectWord(v: any) {
    this.selectWord = v;
  }

  setWords(v: any) {
    this.words = v;
  }

  setSensitiveIds(v: number[]) {
    this.sensitiveIds = v;
  }

  updateItemChecked(pIndex, index) {
    // this.re
  }

  updateResultMap(id, v: IResultMap) {
    if (this.resultMap[id]) {
      this.resultMap[id] = { ...this.resultMap[id], ...v };
    } else {
      this.resultMap[id] = v;
    }
  }

  clearResultMap() {
    this.resultMap = {};
  }
}

const seoStore = new SeoStore();

export default seoStore;
